<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/germany/ahr')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/germany/ahr/jean-stodden')">Jean Stodden
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/germany/ahr')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Jean Stodden</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Il Pinot Nero tedesco è stato a lungo il segreto dei collezionisti di vino intelligenti. Mentre la maggior parte delle persone crede
                        il notoriamente volubile frutto ha origini francesi (ma possiamo mai esserne sicuri?), parecchie
                        altri paesi con climi simili alla Borgogna stanno producendo ottimi vini utilizzando il Pinot. E
                        Jean Stodden, con i suoi vini dal colore intenso e setosi, è stato a lungo un piacere colpevole.
                        <br><br>
                        La Germania è il terzo produttore di Pinot Nero (dopo Francia e Stati Uniti), quindi forse non è così sorprendente trovare vini eccellenti e degni di invecchiamento provenienti dal paese. Con sede ad Ahr, la famiglia Stodden si occupa di viticoltura da secoli, infatti la prima testimonianza del loro nome legato al vino (Riesling, che tuttora producono) risale al 1578. Tuttavia, fu Alois Stodden a mettere davvero la cantina sulla mappa, quando piantò i loro pregiati Pinot nel 1900.
                    </div>

                    <div class="howto-title2">Un vino moderno ha bisogno di un tocco moderno</div>
                    <div class="howto-text">
                        Oggi la tenuta è gestita da Alessandro (che ha rilevato la tenuta nel 2006, iniziando dalle cantine
                        nel 2001), la quinta generazione di Stodden per capire come utilizzare al meglio la famiglia
                        7 ettari. Considerando che in passato la superba reputazione di Stodden era stata per l'aridità dei loro
                        vini, Alexander sta portando il vino in una nuova direzione. Ha cambiato i sistemi di fermentazione in
                        per esaltare l'eleganza del frutto, che ha conferito al suo vino una qualità molto più morbida. Lui
                        convertiti anche a metodi di agricoltura sostenibile come la raccolta manuale e, ove necessario,
                        vendanges vertes. Questo gli è valso molto successo di critica, in particolare da Decanter. La rivista
                        gli ha conferito il titolo di "miglior Pinot Nero al mondo fuori dalla Borgogna" per il suo Spätburgunder, Alte
                        Reben 2010. Il vino ha battuto altri 80 provenienti da Australia, Nuova Zelanda, Sud Africa e Stati Uniti. Lui ha
                        vinse anche quattro uve da Gault et Millau ed Eichelmann gli assegnò cinque stelle e lo nominò
                        produttore di vino dell'anno nel 2014.
                    </div>

                    <div class="howto-title2">Vittima del proprio successo</div>
                    <div class="howto-text">
                        Tutti gli elogi hanno portato a un'immensa popolarità per i nove rossi e un bianco di Jean Stodden. Molti di
                        questi hanno un prezzo molto ragionevole, quindi mentre investi in un caso o due non sarà troppo difficile per te
                        pocket, ma trovare i vini potrebbe essere un po' più difficile. A partire dal secondo trimestre del 2019 solo una bottiglia di
                        Jean Stodden Recher Herrenberg Spatburgunder Grosses Gewachs, 2016 (91 punti punteggio complessivo)
                        era disponibile su wine-searcher.com. Altre cuvée e annate erano più o meno le stesse.
                    </div>

                    <div class="howto-title2">Fatti e annate notevoli</div>
                    <div class="howto-text">
                        <ul>
                            <li>Nel settembre 2017, Jancis Robinson di FT ha elencato 2015 Jean Stodden Recher Herrenberg come
                                uno dei Grosse Gewachs Pinot di Ahr preferiti nel suo “The rise of German noir”
                                articolo.
                            </li>
                            <li>In Arh, settembre 2018, Imbibe ha registrato Jean Stodden affermando "Il miglior tempo,
                                uve fantastiche – tutto sembra essere perfetto”, suggerendo un ottimo investimento
                                opportunità per chi ha la fortuna di mettere le mani sui suoi Pinot 2018.
                            </li>
                            <li>Vinum Wine Guide 2018 nominato Jean Stodden “Winemaker of the Year Ahr: 8 wines with 90
                                punti e altro ancora" sottolineando "Un altro fiore all'occhiello di quest'anno è stato lo Spatburgunder Alte Reben".
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Jean Stodden</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Der deutsche Pinot Noir ist seit langem das Geheimnis der klugen Weinsammler. Während die meisten Leute glauben
                        Die bekanntermaßen launische Frucht hat französischen Ursprung (aber können wir uns dessen jemals sicher sein?), mehrere
                        Andere Länder mit einem ähnlichen Klima wie Burgund produzieren hervorragende Weine aus Pinot. Und
                        Jean Stodden ist mit seinen farbintensiven, seidigen Weinen schon lange ein Genuss.
                        <br><br>
                        Deutschland ist der drittgrößte Produzent von Pinot Noir (nach Frankreich und den USA), daher ist es vielleicht nicht so überraschend, ausgezeichnete, altersgerechte Weine aus dem Land zu finden. Die in Ahr ansässige Familie Stodden betreibt seit Jahrhunderten Weinbau. Die erste Erwähnung ihres Namens im Zusammenhang mit Wein (Riesling, den sie noch heute produzieren) stammt aus dem Jahr 1578. Der eigentliche Gründer des Weinguts war jedoch Alois Stodden auf der Karte, als er im Jahr 1900 ihre wertvollen Pinots anpflanzte.
                    </div>

                    <div class="howto-title2">Ein moderner Wein braucht einen modernen Touch</div>
                    <div class="howto-text">
                        Heute wird das Weingut von Alexander geführt (der das Anwesen 2006 übernahm, beginnend in den Kellern).
                        im Jahr 2001), die fünfte Generation von Stoddens, um zu verstehen, wie man das Eigentum der Familie am besten nutzt
                        7 Hektar. Stodden hatte in der Vergangenheit einen ausgezeichneten Ruf wegen seiner Trockenheit
                        Weine gibt Alexander dem Wein eine neue Richtung. Er änderte die Fermentationssysteme
                        um die Eleganz der Frucht hervorzuheben, die seinem Wein eine viel weichere Qualität verleiht. Er
                        auch auf nachhaltige Anbaumethoden wie Handernte umgestellt und ggf.
                        vendanges vertes. Dies hat ihm viel Lob von der Kritik eingebracht, insbesondere von Decanter. Die Zeitschrift
                        verlieh ihm für seinen Spätburgunder Alte den Titel „Bester Pinot Noir der Welt außerhalb Burgunds“.
                        Reben 2010. Der Wein schlug 80 andere aus Australien, Neuseeland, Südafrika und den USA. Er hat
                        gewann außerdem vier Trauben von Gault et Millau und Eichelmann verlieh ihm fünf Sterne und benannte ihn
                        Weinproduzent des Jahres 2014.
                    </div>

                    <div class="howto-title2">Ein Opfer seines eigenen Erfolgs</div>
                    <div class="howto-text">
                        All das Lob hat dazu geführt, dass die neun Rotweine und ein Weißwein von Jean Stodden eine immense Popularität erlangten. Viele von
                        Diese sind sehr preisgünstig, so dass die Investition in ein oder zwei Koffer für Sie nicht allzu schwer sein wird
                        Tasche, aber die Weine zu finden könnte etwas schwieriger sein. Ab dem 2. Quartal 2019 nur noch eine Flasche
                        Jean Stodden Recher Herrenberg Spatburgunder Grosses Gewächs, 2016 (91 Punkte Gesamtpunktzahl)
                        war auf wine-searcher.com verfügbar. Andere Cuvées und Jahrgänge waren mehr oder weniger gleich.
                    </div>

                    <div class="howto-title2">Bemerkenswerte Fakten und Jahrgänge</div>
                    <div class="howto-text">
                        <ul>
                            <li>Im September 2017 listete Jancis Robinson von FT Jean Stodden Recher Herrenberg aus dem Jahr 2015 auf
                                einer der beliebtesten Großen Gewächs-Pinots von der Ahr in ihrem „Der Aufstieg des deutschen Noir“
                                Artikel.
                            </li>
                            <li>In Arh, September 2018, hat Imbibe Jean Stodden zu Protokoll gegeben: „Bestes Wetter,
                                „Fantastische Trauben – alles scheint perfekt zu sein“, was auf eine hervorragende Investition schließen lässt
                                Gelegenheiten für diejenigen, die das Glück haben, seine 2018er Pinots in die Hände zu bekommen.
                            </li>
                            <li>Vinum Wine Guide 2018 ernannte Jean Stodden zum „Winzer des Jahres Ahr: 8 Weine mit 90
                                Punkte und mehr“ und bemerkte: „Ein weiteres Prunkstück in diesem Jahr war der Spatburgunder Alte Reben.“
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Jean Stodden</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Le pinot noir allemand est depuis longtemps le secret des collectionneurs de vin intelligents. Alors que la plupart des gens croient
                        le célèbre fruit volage a des origines françaises (mais peut-on jamais en être sûr ?), plusieurs
                        d'autres pays aux climats similaires à la Bourgogne produisent d'excellents vins à base de Pinot. Et
                        Jean Stodden, avec ses vins aux couleurs profondes et soyeuses, a longtemps été un plaisir coupable.
                        <br><br>
                        L'Allemagne est le troisième producteur de Pinot Noir (après la France et les États-Unis), il n'est donc peut-être pas surprenant de trouver d'excellents vins de garde du pays. Basée à Ahr, la famille Stodden vit dans la viticulture depuis des siècles, en fait, le premier enregistrement de leur nom lié au vin (Riesling, qu'ils produisent toujours) remonte à 1578. Cependant, c'est Alois Stodden qui a vraiment mis la cave sur la carte, lorsqu'il a planté leurs précieux pinots en 1900.
                    </div>

                    <div class="howto-title2">Un vin moderne a besoin d'une touche moderne</div>
                    <div class="howto-text">
                        Aujourd'hui le domaine est dirigé par Alexandre (qui a repris le domaine en 2006, en commençant par les chais
                        en 2001), la cinquième génération de Stoddens à comprendre comment utiliser au mieux
                        7 hectares. Alors que dans le passé la superbe réputation de Stodden avait été pour la sécheresse de leur
                        vins, Alexander donne au vin une nouvelle direction. Il a changé les systèmes de fermentation en
                        afin de faire ressortir l'élégance du fruit, ce qui a donné à son vin une qualité beaucoup plus douce. Il
                        également convertis à des méthodes agricoles durables telles que la récolte manuelle et, si nécessaire,
                        vendanges vertes. Cela lui a valu de nombreux éloges de la critique, notamment de Decanter. Le magazine
                        lui décerne le titre de « meilleur pinot noir du monde hors Bourgogne » pour son Spätburgunder, Alte
                        Reben 2010. Le vin a battu 80 autres vins d'Australie, de Nouvelle-Zélande, d'Afrique du Sud et des États-Unis. Il a
                        a également remporté quatre raisins du Gault et Millau et Eichelmann lui a décerné cinq étoiles et l'a nommé
                        producteur de vin de l'année en 2014.
                    </div>

                    <div class="howto-title2">Victime de son propre succès</div>
                    <div class="howto-text">
                        Tous les éloges ont conduit à une immense popularité pour les neuf rouges et un blanc de Jean Stodden. Un grand nombre de
                        ceux-ci sont à un prix très raisonnable, donc tout en investissant dans un cas ou deux ne sera pas trop difficile pour votre
                        poche, mais trouver les vins pourrait être un peu plus difficile. Au deuxième trimestre 2019, une seule bouteille de
                        Jean Stodden Recher Herrenberg Spatburgunder Grosses Gewachs, 2016 (score cumulé de 91 points)
                        était disponible sur wine-searcher.com. Les autres cuvées et millésimes étaient plus ou moins les mêmes.
                    </div>

                    <div class="howto-title2">Faits marquants et millésimes</div>
                    <div class="howto-text">
                        <ul>
                            <li>En septembre 2017, Jancis Robinson de FT a répertorié le 2015 Jean Stodden Recher Herrenberg comme
                                l'un des Grosse Gewachs Pinots préférés d'Ahr dans son "The rise of German noir"
                                article.
                            </li>
                            <li>À Arh, en septembre 2018, Imbibe a enregistré Jean Stodden en déclarant "Meilleur temps,
                                raisins fantastiques - tout semble être parfait », suggérant un excellent investissement
                                opportunités pour ceux qui ont la chance de mettre la main sur ses Pinots 2018.
                            </li>
                            <li>Le Guide des vins Vinum 2018 nommé Jean Stodden « Vigneron de l'année Ahr : 8 vins dont 90
                                points et plus » notant « Une autre pièce maîtresse cette année était le Spatburgunder Alte Reben.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Jean Stodden</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        German Pinot Noir has long been the clever wine collectors’ secret. While most people believe
                        the famously fickle fruit has French origins (but can we ever be sure of such things?), several
                        other countries with similar climates to Burgundy are producing excellent wines using Pinot. And
                        Jean Stodden, with his deep-coloured, silky wines, has long been a guilty pleasure.
                        <br><br>
                        Germany is the third producer of Pinot Noir (after France and the USA), so perhaps it is not that surprising to find excellent, age-worthy wines from the country. Based in Ahr, the Stodden family has been in viticulture for centuries, in fact, the first record of their name connected to wine (Riesling, which they still produce) dates back to 1578. However, it was Alois Stodden who really put the winery on the map, when he planted their prized Pinots in 1900.
                    </div>

                    <div class="howto-title2">A modern wine needs a modern touch</div>
                    <div class="howto-text">
                        Today the estate is run by Alexander (who took over the estate in 2006, starting in the cellars
                        in 2001), the fifth generation of Stoddens to understand how best to use the family’s
                        7-hectares. Whereas in the past Stodden’s superb reputation had been for the dryness of their
                        wines, Alexander is taking the wine a new direction. He changed the fermentation systems in
                        order to bring out the elegance of the fruit, which has given his wine a much softer quality. He
                        also converted to sustainable farming methods such as hand harvesting and, where necessary,
                        vendanges vertes. This has won him much critical acclaim, notably from Decanter. The magazine
                        awarded him title of ‘best Pinot Noir in the world outside Burgundy’ for his Spätburgunder, Alte
                        Reben 2010. The wine beat 80 others from Australia, New Zealand, South Africa and the US. He has
                        also won four grapes from Gault et Millau and Eichelmann awarded him five stars and named him
                        wine producer of the year in 2014.
                    </div>

                    <div class="howto-title2">A victim of its own success</div>
                    <div class="howto-text">
                        All the praise has led to immense popularity for the Jean Stodden nine reds and a white. Many of
                        these are very reasonably priced, so while investing in a case or two won’t be too hard on your
                        pocket, but finding the wines might be a little bit harder. As of Q2 2019 just one bottle of
                        Jean Stodden Recher Herrenberg Spatburgunder Grosses Gewachs, 2016 (91 points aggregate score)
                        was available on wine-searcher.com. Other cuvees and vintages were more or less the same.
                    </div>

                    <div class="howto-title2">Notable facts and vintages</div>
                    <div class="howto-text">
                        <ul>
                            <li>In September 2017, FT’s Jancis Robinson listed 2015 Jean Stodden Recher Herrenberg as
                                one of favourite Grosse Gewachs Pinots from Ahr in her “The rise of German noir”
                                article.
                            </li>
                            <li>In Arh, September 2018, Imbibe has Jean Stodden on record stating ‘Best weather,
                                fantastic grapes – everything seems to be perfect,’ suggesting excellent investment
                                opportunities for those fortunate enough to get their hands on his 2018 Pinots.
                            </li>
                            <li>Vinum Wine Guide 2018 named Jean Stodden “Winemaker of the Year Ahr: 8 wines with 90
                                points and more” noting “Another showpiece this year was the Spatburgunder Alte Reben.”
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "JeanStodden",
    data() {
        return {
            select: {report: 'Jean Stodden', src: '/wine-guide/germany/ahr/jean-stodden'},
            items: [
                {report: 'Jean Stodden', src: '/wine-guide/germany/ahr/jean-stodden'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Jean Stodden | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the unique wine-making craftsmanship of Jean Stodden, a renowned wine producer specializing in premium quality wines from the Ahr region.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
